export const BACKEND_URL = process.env.REACT_APP_API_URL
export const GOOGLE_ID = process.env.REACT_APP_GOOGLE_TAG_ID
export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY
export const SENTRY_ENV = process.env.REACT_APP_SENTRY_ENV
export const SENTRY_AUTH_TOKEN = process.env.SENTRY_AUTH_TOKEN
export const PIXEL_ID = process.env.REACT_APP_PIXEL_ID
export const INTERCOM_ID = process.env.REACT_APP_INTERCOM_ID
